import { BaseFilterListRequestModel } from "api/baseFilterListModel/BaseFilterListRequestModel";

export class NationListRequestModel extends BaseFilterListRequestModel {
  constructor(data?: {
    name?: string;
    code?: string;
    page?: number,
    limit?: number
  }) {
    super();
    this.name = data?.name;
    this.code = data?.code;
    this.limit = data?.limit;
    this.page = data?.page;
  }
}
